import { render, staticRenderFns } from "./LoginSSOForm.vue?vue&type=template&id=27c65ea8&scoped=true&"
import script from "./LoginSSOForm.vue?vue&type=script&lang=js&"
export * from "./LoginSSOForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginSSOForm.vue?vue&type=style&index=0&id=27c65ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c65ea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VSnackbar})
